export const STARS_CONTAINER_PREFIX = 'BAZAARVOICE-STARS'
export const REVIEWS_CONTAINER_PREFIX = 'BAZAARVOICE-REVIEWS'
export const REVIEWS_SUMMARY_CONTAINER_PREFIX = 'BVRRSummaryContainer'
export const REVIEWS_REVIEWS_CONTAINER = 'BVRRContainer'

export const ERROR_SCRIPT_NOT_LOADED = 'BV API Script is not loaded'
